// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17E8H","footer":"styles_footer__2iT2m"};